export default "__VITE_ASSET__522975b3__"